// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "../static/css/main.css";
import VueI18n from "vue-i18n";
import en from "@/locales/en.json";
import hi from "@/locales/hi.json";
import axios from "axios";

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.prototype.$axios = axios;
const detectedLocale = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const lang = browserLang.toLowerCase().substring(0, 2);

  const supportedLocales = ["en", "hi"];
  if (supportedLocales.includes(lang)) {
    return lang;
  }

  return "en";
};

const i18n = new VueI18n({
  locale: detectedLocale(),
  messages: {
    en,
    hi,
  },
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js